// Dati di Profile V2: l'utente con ruoli e People Manager, i suoi riporti diretti e i progetti assegnati.
import { API_ENDPOINTS } from '../config/api.config';
import { parseLocalDate } from './dateHelpers';

async function request(url) {
  const res = await fetch(url);
  let body = null;
  try {
    body = await res.json();
  } catch (e) {
    body = null;
  }
  if (!res.ok) throw new Error(body?.error || body?.message || `Request failed (${res.status})`);
  return body || {};
}

/**
 * Profilo dell'utente: dati completi (dall'elenco utenti), People Manager, riporti diretti e progetti.
 * Dei progetti si tengono solo le assegnazioni ancora valide (stessa regola dell'elenco progetti),
 * con i ruoli sul progetto e i team dell'utente.
 */
export async function fetchProfile(userId) {
  const [u, pu, t] = await Promise.all([
    request(API_ENDPOINTS.USERS),
    request(`${API_ENDPOINTS.PROJECT_USERS}?user_id=${userId}`),
    request(`${API_ENDPOINTS.TEAMS}?user_id=${userId}&get_user_memberships=true`).catch(() => ({ teams: [] })),
  ]);
  const users = u.users || [];
  const me = users.find((x) => String(x.id) === String(userId)) || null;
  const manager = me?.id_people_manager ? users.find((x) => String(x.id) === String(me.id_people_manager)) || null : null;
  const reports = users.filter((x) => String(x.id_people_manager) === String(userId)).sort((a, b) => String(a.username).localeCompare(String(b.username)));

  const now = new Date();
  const byProject = new Map();
  (pu.user_projects_with_references || [])
    .filter((a) => !a.validity_end_date || parseLocalDate(a.validity_end_date) > now)
    .forEach((a) => {
      const key = String(a.project?.id);
      if (!byProject.has(key)) {
        byProject.set(key, { id: a.project?.id, name: a.project?.name || '', code: a.project?.project_code || '', active: a.project?.active !== false, customer: a.customer?.name || '', roles: [], teams: [] });
      }
      const row = byProject.get(key);
      if (a.project_role && !row.roles.some((r) => r.id === a.project_role.id)) row.roles.push(a.project_role);
    });
  (t.teams || []).forEach((team) => {
    const row = byProject.get(String(team.project_id));
    if (row && team.name && !row.teams.includes(team.name)) row.teams.push(team.name);
  });
  const projects = [...byProject.values()].sort((a, b) => Number(b.active) - Number(a.active) || a.name.localeCompare(b.name));

  return { me, manager, reports, projects };
}
